import classNames from "classnames";
import React from "react";
import { ReactComponent as ViewCountProfileIcon } from "@ugg/shared/assets/svg/view-count-profile-icon.svg";

interface WatchStreamSelectorProps {
  className: string;
  thumbnail: string;
  stream_title: string;
  streamer_name: string;
  streamer_icon: string;
  view_count: number;
  handleClick: () => void;
}

const WatchStreamSelector: React.FC<WatchStreamSelectorProps> = ({
  className,
  thumbnail,
  stream_title,
  streamer_name,
  streamer_icon,
  view_count,
  handleClick,
}) => {
  const width = 227;
  const height = 128;
  const newThumbnailURL = thumbnail.replace(/{height}/g, height.toString()).replace(/{width}/g, width.toString());
  return (
    <div onClick={handleClick} className={classNames(className)}>
      <div className="stream-thumbnail">
        <img className="stream-thumbnail-img" src={newThumbnailURL}></img>
        <div className="view-count-box">
          <ViewCountProfileIcon className="view-count-icon" />
          <div className="view-count-number">{view_count}</div>
        </div>
      </div>
      <div className="stream-data">
        <img className="stream-icon" src={streamer_icon}></img>
        <div className="stream-data-text">
          <div className="stream-title">{stream_title}</div>
          <div className="stream-name">{streamer_name}</div>
        </div>
      </div>
    </div>
  );
};

export default WatchStreamSelector;
